module.exports = __webpack_public_path__ + "img/sec2_3.1dd91c95.png";